import React from 'react';
import './index.css';
import myFaceImage from './imgs/headshot-transformed.jpeg';

const yearsInEpicor = new Date().getFullYear() - 2013;

function WhyMe() {
  return (
    <section className="detail-page">
      <div className="detail-container">
        <h1 className="detail-title">
          Why Choose <span className="detail-gradient">Me</span>?
        </h1>

        <div className="whyme-hero">
          <div className="whyme-photo-wrap">
            <img
              src={myFaceImage}
              alt="Professional headshot"
              className="whyme-photo"
            />
          </div>
          <div className="whyme-bio">
            <p>
              With <strong>{yearsInEpicor} years of dedicated experience</strong> in working with <em>Epicor ERP</em>,
              I bring a wealth of knowledge and expertise to the table. My journey has allowed me to collaborate
              with <strong>over 50 clients</strong>, both as a valuable team member of a <em>Platinum Partner</em> and as an independent consultant.
            </p>
            <p>
              This diverse exposure has equipped me with a profound understanding
              of a wide array of challenges and solutions within the ERP landscape.
            </p>
            <p>
              My experience spans across various industries, enabling me to offer tailored, effective solutions
              that drive efficiency and growth. Whether you're facing complex issues or seeking to optimize your
              ERP system, I am here to help.
            </p>
            <div className="whyme-cta">
              <p className="whyme-cta-text">Ready to transform your business operations with Epicor ERP?</p>
              <a href="/contact" className="pricing-cta-btn">Get in Touch</a>
            </div>
          </div>
        </div>

        <div className="detail-grid">
          <div className="detail-card">
            <div className="detail-card-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="32" height="32">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
              </svg>
            </div>
            <h2 className="detail-card-title">Expertise</h2>
            <p className="detail-card-desc">Specialized knowledge in Epicor ERP customization, integration, and optimization with {yearsInEpicor} years of hands-on experience.</p>
          </div>

          <div className="detail-card detail-card-accent">
            <div className="detail-card-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="32" height="32">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
              </svg>
            </div>
            <h2 className="detail-card-title">Personalized Service</h2>
            <p className="detail-card-desc">Tailored solutions designed specifically for your business needs, with direct communication and support throughout the process.</p>
          </div>

          <div className="detail-card">
            <div className="detail-card-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="32" height="32">
                <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
              </svg>
            </div>
            <h2 className="detail-card-title">Results-Driven</h2>
            <p className="detail-card-desc">Focused on delivering measurable improvements to your business operations, efficiency, and bottom line.</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhyMe;
